export interface ProductCardTitleProps {
  /** El rótulo pequeño de encima: la categoría, o el gancho si no la hay. */
  label: string;
  /** El nombre del producto, ya traducido. */
  name: string;
}

/**
 * La columna izquierda del bloque inferior de la tarjeta: un rótulo
 * diminuto en versales y el nombre del producto debajo.
 *
 * ── `min-w-0` no es cosmético ────────────────────────────────────────
 * Vive en el padre, y es lo único que impide que un nombre largo desborde
 * su columna del flex y se encime con el precio. Un elemento flex tiene
 * `min-width: auto` por defecto, así que se niega a encogerse por debajo
 * del ancho de su contenido.
 *
 * ── Dos líneas y ni una más ──────────────────────────────────────────
 * `line-clamp-2`: la tarjeta tiene un alto fijo por su proporción 3:4, y
 * un tercer renglón empujaría el nombre fuera del velo, sobre la parte
 * clara de la foto, donde el blanco deja de leerse.
 */
export function ProductCardTitle({ label, name }: ProductCardTitleProps) {
  return (
    <div className="min-w-0 flex-1">
      <p className="mb-1 truncate text-[10px] font-semibold uppercase tracking-[0.2em] text-white/80 drop-shadow-sm">
        {label}
      </p>
      <h3 className="line-clamp-2 break-words text-lg font-semibold leading-tight tracking-tight text-white drop-shadow-sm sm:text-xl">
        {name}
      </h3>
    </div>
  );
}
